/**
 * SHARED
 * Cross-cutting code usable by any module. Must not import from any module.
 *
 * The single, standard "back to the module launcher" control. Every product
 * module renders THIS so the home button is identical everywhere (it matches the
 * Sales Forecasting toolbar button: a left chevron + "Home"). Styling lives in
 * the global `.home-link` rule in styles.css.
 *
 * `onClick` is OPTIONAL and defaults to navigating to "/". It used to be
 * required-by-convention with no default, which made `<HomeButton />` render a
 * button that looked and hovered exactly right and did nothing at all — the
 * Retail Product Finder shipped that way and it took a bug report to notice.
 * A control whose only job is to go home should go home by itself; callers that
 * need to run cleanup first still pass their own handler and win.
 */
import { useNavigate } from "react-router-dom";

export default function HomeButton({ onClick, label = "Home", className = "" }) {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      className={`home-link ${className}`.trim()}
      onClick={onClick ?? (() => navigate("/"))}
      title="Back to home"
    >
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
           strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <polyline points="15 18 9 12 15 6" />
      </svg>
      {label}
    </button>
  );
}
